import React from 'react';
import type { Category, CartItem } from '../types';
import { ProductCard } from './ProductCard';
import './CategorySection.css';

interface CategorySectionProps {
  category: Category;
  cartItems: CartItem[];
  onAddToCart: (productId: number) => void;
  onUpdateQuantity: (itemId: number, quantity: number) => void;
  onProductClick: (productId: number) => void;
}

export const CategorySection: React.FC<CategorySectionProps> = ({
  category,
  cartItems,
  onAddToCart,
  onUpdateQuantity,
  onProductClick,
}) => {
  if (!category.products || category.products.length === 0) {
    return null;
  }

  const getCartItemForProduct = (productId: number) => {
    return cartItems.find(item => item.product_id === productId);
  };

  return (
    <section className="category-section">
      <div className="category-header">
        <h2 className="category-name">{category.name}</h2>
        {category.description && (
          <p className="category-description">{category.description}</p>
        )}
      </div>

      <div className="products-grid">
        {category.products.map((product) => {
          const cartItem = getCartItemForProduct(product.id);
          return (
            <ProductCard
              key={product.id}
              product={product}
              cartQuantity={cartItem?.quantity || 0}
              cartItemId={cartItem?.id}
              onAddToCart={onAddToCart}
              onUpdateQuantity={onUpdateQuantity}
              onProductClick={onProductClick}
            />
          );
        })}
      </div>
    </section>
  );
};
